module.exports = __webpack_public_path__ + "c128f86d3f3506b70d68263bef526523.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/DOC.png
// module id = NC53
// module chunks = 17